/**
 * @module app.bdc.reports.scannetteCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ScannetteCtrl($scope, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        return self;
    }

    ScannetteCtrl.$inject = ['$scope', '$rootScope'];

    angular.module('app.bdc.reports.scannetteCtrl', []).controller('ScannetteCtrl', ScannetteCtrl);
});
